module.exports = __webpack_public_path__ + "static/media/cardDark.e2cff287.png";